export default __webpack_public_path__ + "static/media/nike_stimuli_fr.b9bd2359.mp4";